<!-- update Area Start -->
<div class="modal fade update-modal popCovEr" id="update" tabindex="-1" role="dialog" aria-labelledby="update"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <i class='fas fa-times' style='font-size:24px;color: #fff;'></i>
            </button>
            <div class="modal-bodyUP   p_15" id="update_pass">

                <div class="form-area">
                    <div *ngIf="profileFormState === updateProfileState">
                        <form [formGroup]="updateForm" (ngSubmit)="onFormSubmit()">
                            <div class="header-area">
                                <h4 class="title">My Profile </h4>
                                <!-- <h6 class="sub-title">Update your details below.</h6> -->
                            </div>
                            <div class="form-group">
                                <label for="update-input-update">Username</label>
                                <input autocomplete="off" type="text" class="input-fieldupdate" placeholder="Name"
                                    formControlName="nickname" (focus)="onInputFocus()" [disabled]="true">
                                <small class="error fielderrorUPDA"
                                    *ngIf="!updateForm.get('nickname')?.valid && updateForm.get('nickname')?.touched">
                                    Enter valid username
                                </small>
                            </div>
                            <div class="form-group">
                                <label for="update-input-update">Email</label>
                                <input autocomplete="off" type="text" class="input-fieldupdate" placeholder="Email"
                                    formControlName="email" (focus)="onInputFocus()" [disabled]="true">
                                <small class="error fielderrorUPDA"
                                    *ngIf="!updateForm.get('email')?.valid && updateForm.get('email')?.touched">
                                    Enter valid email
                                </small>
                            </div>
                            <!-- <div class="form-group">
                            <label for="update-input-update">First Name*</label>
                            <input autocomplete="off" type="text" class="input-field" 
                                placeholder="Enter your First Name" formControlName="firstName" (focus)="onInputFocus()">
                            <small class="error fielderror"
                                *ngIf="!updateForm.get('firstName').valid && updateForm.get('firstName').touched">
                                Enter valid First Name!
                            </small>
                        </div>
                        <div class="form-group">
                            <label for="update-input-update">Last Name*</label>
                            <input autocomplete="off" type="text" class="input-field" 
                                placeholder="Enter your Last Name" formControlName="lastName" (focus)="onInputFocus()">
                            <small class="error fielderror"
                                *ngIf="!updateForm.get('lastName').valid && updateForm.get('lastName').touched">
                                Enter valid Last Name!
                            </small>
                        </div> -->
                            <div formGroupName="address">
                                <!-- <div class="form-group">
                                <label for="update-input-update">City*</label>
                                <input autocomplete="off" type="text" class="input-field" 
                                    placeholder="Enter your City" formControlName="city" (focus)="onInputFocus()">
                                <small class="error fielderror"
                                    *ngIf="!updateForm.get('address.city').valid && updateForm.get('address.city').touched">
                                    Enter valid City!
                                </small>
                            </div> -->
                                <div class="form-group">
                                    <label for="update-input-update">Phone</label>
                                    <input autocomplete="off" type="text" class="input-fieldupdate" placeholder="Phone"
                                        formControlName="phone" (focus)="onInputFocus()" [disabled]="true">
                                    <small class="error fielderrorUPDA"
                                        *ngIf="!updateForm.get('address.phone')?.valid && updateForm.get('address.phone')?.touched">
                                        Enter valid Phone
                                    </small>
                                </div>
                                <!-- <div class="form-group" *ngIf="profile">
                                <div *ngIf="profile.address">
                                    <div *ngIf="profile.address.country">
                                        <select formControlName="country">
                                            <option *ngFor="let cnty of country" value="{{cnty.id}}">{{cnty.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div> -->
                            </div>
                            <!-- <span *ngIf="!updateForm.valid && updateForm.touched" class="help-block clr_2">Please enter valid
                            data!</span> -->
                            <!-- <div class="form-group">
                            <button type="submit" class="mybtn1" [disabled]="updateForm.invalid">Update Profile</button>
                        </div> -->
                        </form>
                    </div>
                    <div *ngIf="profileFormState === updatePasswordState">
                        <form [formGroup]="updatePassword" (ngSubmit)="onUpdatePasswordSubmit()">
                            <div class="header-area">
                                <h4 class="title">{{'UPDATE_PASSWORD' | translate}}</h4>
                            </div>
                            <div class="form-group">
                                <label for="update-input-update">{{'OLD_PASSWORD' | translate}}*</label>
                                <input autocomplete="off" type="password" class=""
                                    [placeholder]="'OLD_PASSWORD' | translate" formControlName="oldPassword" (focus)="onInputFocus()"
                                    (keypress)="newpasswordValid($event)">
                                <small class="error fielderrorUPDA"
                                    *ngIf="!updatePassword.get('oldPassword')?.valid && updatePassword.get('oldPassword')?.touched">
                                    <span *ngIf="updatePassword.get('oldPassword')?.errors?.['required']"> {{'ENTER_OLD_PASSWORD' | translate}}
                                    </span>
                                    <span *ngIf="updatePassword.get('oldPassword')?.errors?.['minlength']">{{'_PASSWORD_MUST_BE_MIN_6_CHARACTERS_MAX_15_CHARACTERS' | translate}}</span>
                                    <span *ngIf="updatePassword.get('oldPassword')?.errors?.['maxlength']">{{'_PASSWORD_MUST_BE_MIN_6_CHARACTERS_MAX_15_CHARACTERS' | translate}}</span>
                                    <span *ngIf="updatePassword.get('oldPassword')?.errors?.['pattern']"> {{'ENTER_ALPHABETS_AND_NUMERIC_ONLY' | translate}}
                                    </span>
                                </small>

                            </div>
                            <div class="form-group fd">
                                <label for="update-input-update">{{'NEW_PASSWORD' | translate}}*</label>
                                <!-- <input type=text style="-webkit-text-security: circle;"> -->
                                <input autocomplete="off" style="-webkit-text-security: stars;"
                                    [type]="fieldTextType?'password':'text'" type="password" class=""
                                    [placeholder]="'NEW_PASSWORD' | translate" formControlName="newPassword" (focus)="onInputFocus()"
                                    (keypress)="oldpasswordValid($event)">
                                <span class="iconeyeCHeang" (click)="viewpass()">
                                    <i [ngClass]="changeeye?'far fa-eye-slash':'far fa-eye'" style="color: gray;"></i>
                                </span>
                                <small class="error fielderrorUPDA"
                                    *ngIf="!updatePassword.get('newPassword')?.valid && updatePassword.get('newPassword')?.touched">
                                    <span *ngIf="updatePassword.get('newPassword')?.errors?.['required']">
                                      {{'ENTER_NEW_PASSWORD' | translate}}
                                    </span>
                                    <span *ngIf="updatePassword.get('newPassword')?.errors?.['minlength']">
                                        {{'_PASSWORD_MUST_BE_MIN_6_CHARACTERS_MAX_15_CHARACTERS' | translate}}
                                    </span>
                                    <span *ngIf="updatePassword.get('newPassword')?.errors?.['maxlength']">
                                        {{'_PASSWORD_MUST_BE_MIN_6_CHARACTERS_MAX_15_CHARACTERS' | translate}}
                                    </span>
                                    <span *ngIf="updatePassword.get('newPassword')?.errors?.['pattern']">{{'ENTER_ALPHABETS_AND_NUMERIC_ONLY' | translate}}</span>
                                </small>
                                <div class="infoBox">
                                    <span class="info_regiPass " (click)="showErrorPass()" title="Info">i</span>
                                    <div class="box_massageCang">
                                        <p class="boxerror_useupd">{{'YOUR_PASSWORD_SHOULD_BE_6-15_CHARACTERS' | translate}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <button type="submit" class="mybtn1" [disabled]="updatePassword.invalid">{{'UPDATE_PASSWORD' | translate}}</button>
                            </div>
                        </form>
                    </div> 
                    <div *ngIf="errorMessage" class="alert alert-danger">
                        {{ errorMessage | translate}}
                    </div>
                </div>
            </div>
        </div>


    </div>
</div>
<div class="black_cover" *ngIf="updatePasswordOne" (click)="updatepwdsuccessPopClose()"></div>
<div class="popup_1 pop_sm" *ngIf="updatePasswordOne">
    <span class="casino_pupop" (click)="updatepwdsuccessPopClose()"> <i class='fas fa-times'></i></span>
    <div class="soon font_16">
        {{ErrorMessageS | translate}} <br> <br>
        <button class="btn_comSoon" (click)="updatepwdsuccessPopClose()"> OK </button>
    </div>
</div>
<!-- update Area End -->